import { useFlags } from "launchdarkly-react-client-sdk";

type LaunchDarklyFlags = {
  enableDriverAvailability: boolean;
  enableCustomLocation: boolean;
};

export function useLaunchDarklyFlags(): Partial<LaunchDarklyFlags> {
  return useFlags();
}
